import { Meta } from '@/src/components/common/Meta';
import JamFacilitatorNotes from '@/src/components/game/JamFacilitatorNotes/JamFacilitatorNotes';
import { useAsyncEffect } from '@/src/hooks/useAsyncEffect';
import { useJamChallengeDetails } from '@/src/store/jam-challenge-details.context';
import { useJamEventDetails } from '@/src/store/jam-event-details.context';
import { i18nKeys } from '@/src/utils/i18n.utils';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

export const JamFacilitatorNotesPage: React.FC = () => {
  const { t } = useTranslation();
  const { event } = useJamEventDetails();
  const { selectedJamChallenge, loadJamChallengeDetails } = useJamChallengeDetails();

  const params: { 0: string; 1: string } = useParams();
  const eventName = params[0];
  const challengeId = params[1];

  useAsyncEffect(async () => {
    loadJamChallengeDetails({ id: eventName, challengeId });
  }, [eventName, challengeId]);

  const challengeTitle = selectedJamChallenge?.title ?? t(i18nKeys.meta.challenge.title);
  const eventTitle = event?.title ?? t(i18nKeys.meta.event.title);

  const pageTitle = `${t(
    i18nKeys.myJams.challenges.details.facilitatorNotes.title
  )} | ${challengeTitle} | ${eventTitle}`;

  return (
    <>
      <Meta title={pageTitle} />
      <JamFacilitatorNotes />
    </>
  );
};
